import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureUtmFromUrl } from "@/lib/utmTracking";
import { trackFunnelEvent } from "@/lib/funnelTracking";

/**
 * Mount once globally. On every navigation, scans the URL for utm_* params
 * and persists the first-touch attribution to localStorage. Cheap, runs only
 * when search params change.
 */
export function UtmCapture() {
  const location = useLocation();

  useEffect(() => {
    if (!/utm_|[?&](ref|referral)=/.test(location.search)) return;
    captureUtmFromUrl();
  }, [location.search]);

  // Also capture on initial mount in case the URL has UTMs but the effect above
  // doesn't fire (e.g., direct landing). Records one anonymous landing_view per
  // tab session (server dedupes on visitor+session).
  useEffect(() => {
    captureUtmFromUrl();
    trackFunnelEvent("landing_view");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
